// extracted by mini-css-extract-plugin
export default {"link":"ProductLink_link__qzh+3","active":"ProductLink_active__JzVHR"};